import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const notifications = [['SM', 'Sarah M.', 'London, United Kingdom', '5 minutes ago'], ['CV', 'Clara V.', 'Toronto, Canada', '12 minutes ago'], ['JR', 'James R.', 'Sydney, Australia', '18 minutes ago'], ['AM', 'Anna M.', 'New York, USA', '27 minutes ago']];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 3500);
    const rotate = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(current => (current + 1) % notifications.length);
        setVisible(true);
      }, 500);
    }, 7000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(rotate);
    };
  }, [dismissed]);
  const [initials, name, city, time] = notifications[index];
  return <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 w-full max-w-sm -translate-x-1/2 px-4" data-id="element-211">
      <AnimatePresence data-id="element-212">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 12
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-xl border border-gold-700/50 bg-charcoal p-3.5 shadow-gold" data-id="element-213">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-gold-300 text-xs font-bold text-black" data-id="element-214">
              {initials}
            </span>
            <div className="min-w-0" data-id="element-215">
              <p className="text-xs text-stone-500" data-id="element-216">{city}</p>
              <p className="text-sm text-white" data-id="element-217">
                <strong data-id="element-218">{name}</strong> purchased ESL Teacher Ready™
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] text-emerald-400" data-id="element-219">
                <ShoppingBagIcon size={11} data-id="element-220" />
                Verified purchase · {time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 text-stone-500 transition hover:text-white" data-id="element-221">
              <XIcon size={14} data-id="element-222" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}